import React, { useEffect, useRef, useState } from "react";
import * as Styled from "./styles";
import NumberInput from "../NumberInput";
import { TRange } from "Services/pagination";
import CheckBox from "../CheckBox";
import { useFilters } from "Contexts/FiltersContext";

type TChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface Props {
  title?: string;
  name: string;
  suffix?: string;
  isCurrency?: boolean;
  values?: TRange;
  undefinedValues?: boolean;
  undefinedValuesMessage?: string;
  setUndefinedValues?: React.Dispatch<React.SetStateAction<boolean>>;
  change: React.Dispatch<React.SetStateAction<TRange>>;
  hideSearch?: boolean;
}

const parseValue = (value: string, isCurrency: boolean) => {
  const parsedValue = isCurrency
    ? value.replace(/\D+/g, "")
    : value.replaceAll(".", "").replace(",", ".");

  return parseFloat(parsedValue);
};

const RangeField: React.FC<Props> = ({
  title = "",
  name,
  suffix = "",
  isCurrency = false,
  values = { min: 0, max: 0 },
  undefinedValues,
  setUndefinedValues,
  undefinedValuesMessage = "Incluir não definido",
  change,
  hideSearch,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [maxHeight, setMaxHeight] = useState(0);
  const { registerResetFn } = useFilters();

  useEffect(() => {
    if (contentRef.current) {
      if (!hideSearch) {
        // Expand: calcula a altura real do conteúdo
        setMaxHeight(contentRef.current.scrollHeight);
      } else {
        // Collapse
        setMaxHeight(0);
      }
    }
  }, [hideSearch]);

  useEffect(() => {
    registerResetFn(() => {
      change({ min: 0, max: 0 });
      setUndefinedValues && setUndefinedValues(true);
    });
  }, []);

  return (
    <Styled.Field hideSearch={hideSearch} maxHeight={maxHeight}>
      <div ref={contentRef}>
        {title && <Styled.Title>{title}</Styled.Title>}
        <Styled.Labels>
          <Styled.Label>
            <NumberInput
              name={name}
              label="De"
              suffix={suffix}
              isCurrency={isCurrency}
              value={isCurrency ? values.min / 100 : values.min}
              onChange={(e: TChangeEvent) => {
                change({
                  ...values,
                  min: parseValue(e.target.value, isCurrency),
                });
              }}
            />
          </Styled.Label>
          <Styled.Label>
            <NumberInput
              name={name}
              label="Até"
              suffix={suffix}
              isCurrency={isCurrency}
              value={isCurrency ? values.max / 100 : values.max}
              onChange={(e: TChangeEvent) => {
                change({
                  ...values,
                  max: parseValue(e.target.value, isCurrency),
                });
              }}
            />
          </Styled.Label>
        </Styled.Labels>
        {setUndefinedValues && typeof undefinedValues !== "undefined" && (
          <CheckBox
            checked={undefinedValues}
            defaultValue={undefinedValues}
            change={() => {
              setUndefinedValues(!undefinedValues);
            }}
          >
            {undefinedValuesMessage}
          </CheckBox>
        )}
      </div>
    </Styled.Field>
  );
};
export default RangeField;
